import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    container: {
      color: theme.colors.common12,
    },
    bodyContainer: {
      backgroundColor: theme.colors.common2,
      padding: theme.spacing(7, 4),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(7, 2),
      },
    },
    boxWrapper: {
      backgroundColor: theme.colors.common11,
    },
    sessionHeader: {
      border: `1px solid ${theme.colorTokens.outlineVariant}`,
      borderRadius: '4px 4px 0 0',
      backgroundColor: theme.colors.common6,
      color: theme.palette.getContrastText(theme.colors.common6),
    },
    sessionHeaderTitle: {
      fontSize: '2rem',
      fontWeight: 700,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.4rem',
      },
    },
    sessionBody: {
      border: `1px solid ${theme.colorTokens.outlineVariant}`,
      backgroundColor: theme.colors.common11,
    },
    sessionBodyTitle: {
      fontSize: '1.2rem',
      fontWeight: 700,
      textDecoration: 'underline',
    },
    editItemHeader: {
      fontSize: '14px',
    },
    editItem: {
      backgroundColor: theme.colors.common2,
      color: theme.colors.common3,
      padding: theme.spacing(3),
      marginBottom: '10px',
      '&:last-of-type': {
        marginBottom: 0,
      },
      '& strong': {
        color: theme.colors.common12,
      },
      [theme.breakpoints.down('sm')]: {
        backgroundColor: 'transparent',
        padding: 0,
      },
    },
    deliveryWindowLabel: {
      fontSize: '13px',
    },
    locationMapWrapper: {
      paddingLeft: '20px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        marginTop: '10px',
      },
    },
    locationMap: {
      height: 'calc(100% - 50px)',
      [theme.breakpoints.down('sm')]: {
        height: '300px',
      },
    },
    mapEdit: {
      backgroundColor: theme.colors.common2,
      boxSizing: 'border-box',
      height: '100%',
      [theme.breakpoints.down('sm')]: {
        padding: 0,
        backgroundColor: 'transparent',
      },
    },
    dialogPaper: {
      overflowScrolling: 'touch',
      WebkitOverflowScrolling: 'touch',
    },
    dialogOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(230, 230, 230, 0.5)',
    },
    dialogOverlayProgress: {
      position: 'absolute',
      top: '45%',
      left: '45%',
    },
    dialogMethodSelectTitle: {
      borderBottom: `1px solid ${theme.colorTokens.outlineVariant}`,
      borderBottomColor: theme.colors.common4,
    },
    dialogActionsWrapper: {
      padding: theme.spacing(2, 3),
      justifyContent: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-end',
      },
    },
    button: {
      borderRadius: '40px',
      textTransform: 'initial',
      fontWeight: 600,
      boxShadow: 'none',
      display: 'inline-block',
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
    },
    dialogButton: {
      textTransform: 'uppercase',
      minWidth: '130px',
      display: 'inline-block',
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '110px',
      },
    },
    optButton: {
      width: '100%',
      textTransform: 'none',
    },
    titleBox: {
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 0,
      },
    },
    dialogTitle: {
      fontSize: '24px',
      color: theme.colors.common12,
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
        fontSize: '20px',
        '& > h2': {
          fontSize: '16px',
        },
      },
    },
    dialogBodyText: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
      },
    },
    dialogTimer: {
      color: theme.colors.common9,
    },
    timerCounter: {
      display: 'inline-block',
      marginLeft: '5px',
      minWidth: '40px',
    },
    noticeText: {
      fontStyle: 'italic',
      fontWeight: 600,
      lineHeight: 1.5,
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
    noticeBox: {
      borderBottom: `1px solid ${theme.colors.common4}`,
      fontStyle: 'italic',
      fontWeight: 600,
      lineHeight: 1.5,
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
    noticeSignatureBox: {
      borderBottom: `1px solid ${theme.colors.common4}`,
      fontStyle: 'italic',
      lineHeight: 1.5,
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
    infoBox: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
    addressEdit: {
      [theme.breakpoints.down('sm')]: {
        '& .MuiGrid-grid-sm-10': {
          marginBottom: '20px',
        },
      },
    },
    addressInputWrapper: {
      padding: theme.spacing(0, 2) + ' !important',
      [theme.breakpoints.down('sm')]: {
        padding: '0 !important',
      },
    },
    addressInput: {
      width: '400px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    countdownTimer: {
      fontWeight: 600,
      marginLeft: '5px',
      verticalAlign: 'middle',
    },
    shipmentDetails: {
      borderBottom: `1px solid ${theme.colorTokens.outlineVariant}`,
    },
    shipmentDetailsContent: {
      '& > div:not(:last-of-type)': {
        [theme.breakpoints.down('sm')]: {
          marginBottom: '10px',
        },
      },
    },
    inputField: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
    clientLogo: {
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
    marginBottom: {
      marginBottom: '10px',
    },
    grayText: {
      color: theme.colors.common4,
    },
    darkGrayText: {
      color: theme.colors.common3,
    },
    redColor: {
      color: theme.colors.common10,
    },
    bolded: {
      fontWeight: 600,
    },
    underlined: {
      textDecoration: 'underline',
    },
    selfCenter: {
      alignSelf: 'center',
    },
    disabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      '& .MuiFormControlLabel-root.Mui-disabled': {
        cursor: 'not-allowed',
      },
    },
  };
};
